import React from 'react';

import {
  Card as ThemeCard,
  CardProps,
  Input,
  InputProps,
  Label
} from 'theme-ui';
import { layout, LayoutProps, border, BorderProps } from 'styled-system';
import { Form as FormikForm, ErrorMessage, Field } from 'formik';

import styled from 'styled-components';

const StyledForm = styled(FormikForm)`
  display: flex;
  flex-direction: column;
`;

const StyledErrorMessage = styled(ErrorMessage)`
  color: red;
`;

const Card = styled(ThemeCard)<CardProps & LayoutProps & BorderProps>(
  layout,
  border
);

const FormInput: React.FC<InputProps> = ({ children, ref, ...rest }) => (
  <Input as={Field} {...rest}>
    {children}
  </Input>
);

const StyledLabel = styled(Label)``;

const Form: React.FC & {
  Error: typeof StyledErrorMessage;
  Field: typeof FormInput;
  Label: typeof StyledLabel;
} = ({ children, ...rest }) => (
  <Card margin="0 auto" maxWidth={700} bg="muted" p={4} borderRadius={10}>
    <StyledForm {...rest}>{children}</StyledForm>
  </Card>
);

Form.Error = StyledErrorMessage;

Form.Field = FormInput;

Form.Label = StyledLabel;

export default Form;
